import onEnvironmentChange from '@/observables/environment.observable'
import type Environment from '@interfaces/environment.interface'
import type MySquid from '@interfaces/my-squid.interface'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import type { Axios, AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class ElektraService extends MainService {
  url: string
  logServce = new LogService()
  http: any

  constructor(elektraUrl?: string, http?: Axios) {
    super()
    if (http) {
      this.http = http
    }
    if (!elektraUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.elektra
      })
    } else {
      this.url = elektraUrl
    }
    this.logServce.init('Elektra Service')
  }

  public async getConfigByHeader(): Promise<MySquid> {
    return await this.http
      .get(`${this.url}/api/webapp/config`)
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logServce.error({
          message: 'Error on get config by header',
          error,
        })
        return error.response
      })
  }
  public async getConfigById(idWebapp: string): Promise<MySquid> {
    if (!idWebapp) {
      throw new Error('idWebapp required in getConfigById')
    }
    return await this.http
      .get(`${this.url}/api/nps/webapp/${idWebapp}`)
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logServce.error({
          message: 'Error on get config by id',
          error,
        })
        throw error.response
      })
  }
}
